import { Menu } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { getLayout, setMobileMenuOpen } from 'src/redux/slices/layout';
import useResponsive from 'src/utils/hooks/useResponsive';
import styled from 'styled-components';

import useLinks from '../useLinks';
import AccountSelector from './AccountSelector';
import CurrentUser from './CurrentUser';
import { StyledHeader, StyledMobileHeader } from './Styles';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const BetaText = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: #ffffff;
  font-style: italic;
  padding-bottom: 2px;

  p {
    margin-top: 27px;
  }
`;

type Props = {
  onLogout: () => void;
};

const Header = ({ onLogout }: Props) => {
  const { t } = useTranslation();
  const { mobileMenuOpen } = useSelector(getLayout);
  const dispatch = useDispatch();
  const { links, mobileLinks, current } = useLinks();
  const navigate = useNavigate();
  const { isMobileOrTablet } = useResponsive();

  const handleAccountSubmit = () => {
    navigate(ROUTES.INVENTORY);
  };

  return (
    <>
      {/* Desktop header */}
      {!isMobileOrTablet && (
        <StyledHeader>
          <>
            <div className="account-selector">
              <LogoContainer>
                <img src="/images/logo-sider.svg" alt="logo" />
                <BetaText>
                  <p>Beta</p>
                </BetaText>
              </LogoContainer>
              <AccountSelector onSubmit={handleAccountSubmit} />
            </div>

            <div className="menu-wrapper">
              <Menu
                mode="horizontal"
                items={links}
                selectedKeys={[current]}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  border: 'none',
                  background: 'transparent',
                  flex: 'none',
                  width: 'auto',
                }}
              />
            </div>

            <div className="user-controls">
              <CurrentUser onLogout={onLogout} />
            </div>
          </>
        </StyledHeader>
      )}

      {/* Mobile menu open */}
      <StyledMobileHeader
        title={null}
        placement="left"
        onClose={() => dispatch(setMobileMenuOpen(false))}
        open={mobileMenuOpen}
        width={280}
        mask={true}
        maskClosable={true}
      >
        <div>
          <Menu
            mode="vertical"
            items={mobileLinks}
            selectedKeys={[current]}
            onClick={() => dispatch(setMobileMenuOpen(false))}
          />
          <div className="account-selector-mobile">
            <AccountSelector onSubmit={handleAccountSubmit} />
          </div>
          <Menu
            items={[
              {
                key: 'settings',
                label: t('profileScreen:page_title'),
                onClick: () => navigate(ROUTES.PROFILE),
              },
              {
                key: 'logout',
                label: t('layout:logout'),
                onClick: () => onLogout(),
              },
            ]}
            mode="vertical"
          />
        </div>
      </StyledMobileHeader>
    </>
  );
};

export default Header;
